import confetti from '../../utils/confetti';

class CartShipping extends HTMLElement {
  constructor() {
    super();

    this.total = Number(this.querySelector('[data-cart-total]')?.dataset?.cartTotal) / 100 || 0; // Total price of the cart
    this.isInternational = window.theme.country_iso !== 'US';
    this.threshold = Number(this.dataset.freeShippingThreshold);
    this.remaining = 0;
    this.onlyGiveX = false;

    if (this.isInternational && window.theme.free_shipping_bar.free_shipping_international_threshold) {
      this.threshold = window.theme.free_shipping_bar.free_shipping_international_threshold;
    }

    this.remaining = this.threshold - this.total;
    this.confettiFired = false;
  }

  connectedCallback() {
    this.initializeComponent();
  }

  getCartTotal() {
    return Number(this.querySelector('[data-cart-total]')?.dataset?.cartTotal) / 100 || 0;
  }

  setProgressBar() {
    const progressContainer = this.querySelector('.FreeShippingBar__progress-container');
    if (this.threshold === 0 || this.onlyGiveX) {
      // we will throw confetti if the threshold is 0 or if the cart has only giveX products
      if (progressContainer) {
        this.fireConfetti();
        return (progressContainer.style.display = 'none');
      }
    }
    if (progressContainer.style.display === 'none' && !(this.threshold === 0 || this.onlyGiveX)) {
      progressContainer.style.display = '';
      this.fireConfetti(); // this will be called to reset the confettiFired flag if it is necessary
    }

    const progressRatio = this.total >= this.threshold ? 1 : this.total / this.threshold;
    const progressPercentage = progressRatio * 100;

    const freeShippingProgressBar = this.querySelector('.FreeShippingBar__progress');
    if (!freeShippingProgressBar) return;

    // Deferring the confetti firing until the progress bar transition ends
    freeShippingProgressBar.addEventListener('transitionend', () => this.fireConfetti());

    freeShippingProgressBar.style.transform = `translate3d(-${100 - progressPercentage}%, 0, 0)`;

    if (this.remaining <= 0) {
      freeShippingProgressBar.style.background = '#60269E';
    } else {
      freeShippingProgressBar.style.background = '#92959B';
    }
  }

  fireConfetti() {
    // Go off confetti if the remaining is 0 or less than 0 or if the cart got into onlyGivex mode
    // the onlyGivex mode is set when the cart has only GIVEX products or threshold is 0
    if (!this.confettiFired && (this.remaining <= 0 || this.threshold === 0 || this.onlyGiveX)) {
      const confettiPot = document.getElementById('confetti-canvas'); // custom canvas
      const confettiObj = confetti.create(confettiPot, { resize: true });

      confettiObj({ origin: { y: 0.7 } });
      this.confettiFired = true;
    } else if (this.confettiFired && !this.onlyGiveX && this.threshold !== 0 && this.remaining > 0) {
      this.confettiFired = false;
    }

    this.querySelector('.FreeShippingBar__progress').removeEventListener('transitionend', this.fireConfetti);
  }

  updateProgressBar(mutationList) {
    for (const mutation of mutationList) {
      if (mutation.type === 'childList') {
        if (mutation.target.querySelector('[data-cart-total]')) {
          // Set this.onlyGivex if the cart has only giveX products
          const hasOnlyGiveX = this.querySelector('[has-only-givex]');
          if (hasOnlyGiveX) {
            this.onlyGiveX = true;
          } else {
            this.onlyGiveX = false;
          }

          this.total = this.getCartTotal();
          this.remaining = this.threshold - this.total;

          this.setProgressBar(); // Update progress bar
        }
      }
    }
  }

  initializeComponent() {
    const hasOnlyGiveX = this.querySelector('[has-only-givex]');
    if (hasOnlyGiveX) {
      this.onlyGiveX = true;
    }

    this.setProgressBar(); // Update progress bar

    // Select the node that will be observed for mutations
    const targetNode = document.getElementById('free-shipping-container');

    // Options for the observer (which mutations to observe)
    const config = { attributes: true, childList: true, subtree: true };

    // Create an observer instance linked to the callback function
    const observer = new MutationObserver(this.updateProgressBar.bind(this));

    // Start observing the target node for configured mutations
    observer.observe(targetNode, config);
  }
}

export default CartShipping;
